import { PageTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { Header, VertSpacerMd, VertSpacerSm } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { IAppNavigation } from '@apps-common/hooks/useNavigation'
import { ROUTE_CREATE_UNIT_ACTIVATION, ROUTE_UNIT_ACTIVATIONS } from '@apps-radionet-portal-root/src/config/private-routes'

import { UnitActivationFilterButton } from './UnitActivationFilterButton'

interface IProps {
  navigation: IAppNavigation
  children?: React.ReactNode
}

export const UnitActivationHeader: React.FC<IProps> = ({ navigation, children }) => {
  const { navigateForward } = navigation

  return (
    <Header>
      <Navbar transparent showBack />
      <Breadcrumbs route={ROUTE_UNIT_ACTIVATIONS} />
      <div className='flex items-end justify-between'>
        <PageTitle>Device Activations</PageTitle>
        <div className='flex items-center justify-end gap-[5px]'>
          <ButtonRoundLg
            type='button'
            className='action-success'
            callback={() => {
              navigateForward({
                routeUrl: ROUTE_CREATE_UNIT_ACTIVATION.buildPath(),
                route: ROUTE_CREATE_UNIT_ACTIVATION
              })
            }}
          >
            <commonIcons.add />
          </ButtonRoundLg>
          <UnitActivationFilterButton />
        </div>
      </div>
      {!children && <VertSpacerSm />}
      {children && (
        <>
          <VertSpacerMd />
          {children}
          <VertSpacerSm />
        </>
      )}
    </Header>
  )
}
